<template>
  <div>
    <el-page-header @back="goBack" :content="titleText" />
    <div class="info-body">
      <div class="title outside">{{ titleText }}</div>
      <!-- 缩略图 -->
      <div class="thumb outside">
        <!-- <img :src="scenicInfo.thumb" alt /> -->
        <el-image
          fit="contain"
          :src="scenicInfo.thumb"
          :preview-src-list="[scenicInfo.thumb]"
        ></el-image>
      </div>
      <!-- 基础信息 -->
      <div class="basis-info outside">
        <div class="modtitle">基础信息</div>
        <div v-if="!scenicInfo.info" class="no-basis">
          <el-button type="text" disabled>还未设置基础信息</el-button>
          <el-button type="text" @click="setBasisInfo">去设置</el-button>
        </div>
        <div class="basis" v-else>
          <!-- <div>
            <div class="modtitle">图集</div>
            <div class="imgs">
              <div class="img-item" v-for="(item,index) in scenicInfo.info.images" :key="index">
                <el-image fit="cover" :src="item" :preview-src-list="scenicInfo.info.images"></el-image>
              </div>
            </div>
          </div> -->
          <el-button type="text" @click="setBasisInfo(scenicInfo.info)"
            >设置</el-button
          >
          <div class="basis-course outside">
            <div class="basis-tit">景区简介：</div>
            <div class="basis-content">{{ scenicInfo.info.course }}</div>
          </div>
          <div class="basis-prompt outside">
            <div class="basis-tit">景区提示：</div>
            <div class="basis-content">{{ scenicInfo.info.prompt }}</div>
          </div>
          <div class="basis-pre outside">
            <div class="basis-tit">预定提示：</div>
            <div class="basis-content">{{ scenicInfo.info.pre }}</div>
          </div>
          <div class="basis-policy outside">
            <div class="basis-tit">景区政策：</div>
            <div class="basis-content">{{ scenicInfo.info.policy }}</div>
          </div>
        </div>
      </div>
      <!-- 信息 -->
      <div class="info outside">
        <div class="modtitle">基本信息</div>
        <zx-list :listData="scenicInfo" />
      </div>
    </div>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      :form-attrs="{ size: 'small' }"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      title="基础信息"
    />
  </div>
</template>

<script>
import * as scenic from "@/api/product/scenic.js";
import scenicList from "./components/scenic-list.vue";
export default {
  components: {
    "zx-list": scenicList
  },
  data() {
    return {
      formData: {},
      formDesc: {
        images: {
          label: "图集",
          type: "image-uploader",
          attrs: {
            // drag: true, // 多张
            multiple: true,
            size: 100,
            accept: "jpg,jpeg,png",
            action: this.$uploadURL,
            headers: {
              authorization: sessionStorage.getItem("token")
            },
            responseFn(response, file) {
              if (response.code !== 200) {
                this.$message.error(response.msg);
              }
              // 根据响应结果, 设置 URL
              return response.data.url;
            },
            lazy: true
          },
          layout: 24
        },
        course: {
          label: "介绍",
          type: "textarea",
          layout: 24
        },

        prompt: {
          label: "提示",
          type: "textarea"
        },
        pre: {
          label: "预定提示",
          type: "input"
        },
        policy: {
          label: "政策",
          type: "textarea"
        }
      },
      rules: {},
      submitType: 1,
      dialogFormVisible: false,
      titleText: this.$route.query.title,
      id: this.$route.query.id,
      scenicInfo: {}
    };
  },
  created() {
    this.getScenicInfo();
  },
  methods: {
    handleSubmit(form) {
      form["scenic_id"] = this.id;
      scenic.addScenicInfo.r(form).then(res => {
        //   this.$message.success("部门《" + res.dept_name + "》创建成功");
        this.getScenicInfo();
      });
    },
    handleSuccess() {
      this.formData = {};
      this.dialogFormVisible = false;
    },
    setBasisInfo(e) {
      if (e) {
        this.formData = e;
      }
      this.dialogFormVisible = true;
    },
    getScenicInfo() {
      scenic.getScenicInfo.r({ id: this.id }).then(res => {
        this.scenicInfo = res;
      });
    },
    goBack() {
      this.$router.go(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.info-body {
  .outside {
    margin-top: 20px;
  }
  .modtitle {
    text-align: center;
    font-size: 20px;
    margin-bottom: 10px;
  }
  margin: 0 auto;
  width: 80%;
  .title {
    font-size: 40px;
    line-height: 60px;
    text-align: center;
  }
  .thumb {
    display: flex;
    justify-content: center;
    el-image {
      width: 100%;
      height: auto;
    }
  }
  .basis-info {
    .basis {
      .imgs {
        display: flex;
        .img-item {
          height: 100px;
          margin-right: 10px;
          el-image {
            height: 100px;
            width: auto;
          }
        }
      }
      div {
        display: flex;
        .basis-tit {
          font-size: 16px;
        }
        .basis-content {
          font-size: 15px;
          width: 90%;
          margin: 0 auto;
        }
      }
    }
    .no-basis {
      display: flex;
      justify-content: center;
      align-items: center;
      .tit {
        font-size: 18px;
      }
    }
  }
  .info {
    .item {
      display: flex;
      line-height: 45px;
      font-size: 18px;
      &:nth-child(1) {
        border-top: 1px solid #dcdfe6;
      }
      border-bottom: 1px solid #dcdfe6;
      .left {
        font-size: 15px;
        font-weight: 500;
        padding-left: 10px;
        margin-right: 10px;
        color: #909399;
        width: 200px;
        background-color: #f7f7f7;
      }
      .right {
        width: calc(100% - 210px);
        color: #303133;
      }
    }
  }
}
</style>
